import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";
import { ErrorBox } from "./components/common";
import ProjectList from "./components/ProjectList";
import ClientSearch from "./components/ClientSearch";
import { errorMessage, staffDmApi } from "./dmApi";
import "./dm.css";
import "../../assets/css/PageHeading.css";

/**
 * Digital Marketing landing page. Staff search / list DM-enrolled clients and open a client's
 * details page; portal users (api=portalDmApi) go straight to their own company's projects.
 */
function DMProjects({ api = staffDmApi, basePath = "/dm-projects" }) {
  const navigate = useNavigate();
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState("");
  const [infoOpen, setInfoOpen] = useState(false);

  useEffect(() => {
    if (api.isStaff) return;
    api.meta().then(setMeta).catch((err) => setError(errorMessage(err, "Could not load options")));
  }, [api]);

  return (
    <div className="dmp">
      {api.isStaff ? (
        <>
          <div className="co-page-head">
            <div className="dmp-head-title">
              <h2 className="co-page-head__title">Clients</h2>
              <span className={`dmp-info${infoOpen ? " is-open" : ""}`}>
                <button
                  type="button"
                  className="dmp-info__btn"
                  aria-label="Client not listed?"
                  aria-expanded={infoOpen}
                  onClick={() => setInfoOpen((o) => !o)}
                  onBlur={() => setInfoOpen(false)}
                >
                  <FaInfoCircle aria-hidden="true" />
                </button>
                <span className="dmp-info__pop" role="tooltip">
                  <strong>Client not listed?</strong> Digital Marketing is assigned from the client’s edit page (
                  <Link to="/tenants" onMouseDown={(e) => e.preventDefault()}>
                    Clients
                  </Link>{" "}
                  → Edit → services).
                </span>
              </span>
            </div>
          </div>
          <div className="dmp-card dmp-card--clients">
            <ClientSearch
              api={api}
              onSelect={(t) => navigate(`${basePath}/client/${t.tenant_id}`)}
              onViewProjects={(t) => navigate(`${basePath}/client/${t.tenant_id}?tab=dm-projects`)}
            />
          </div>
        </>
      ) : (
        <>
          <div className="cportal-page-head">
            <h1>Digital Marketing</h1>
          </div>
          <ErrorBox message={error} />
          <ProjectList api={api} meta={meta} basePath={basePath} title="Projects" />
        </>
      )}
    </div>
  );
}

export default DMProjects;
